import React from 'react';
import { APP_COPY } from '../../constants/copy';
import './contact.scss';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="contact__title">{APP_COPY.contact.title}</h2>
            <p className="contact__description">{APP_COPY.contact.description}</p>
          </div>
        </div>
        
        <div className="row g-5">
          {/* Contact Information */}
          <div className="col-lg-6 col-md-12">
            <div className="card contact__info-card">
              <div className="card-body">
                <h4 className="card-title">Get in Touch</h4>
                
                <div className="mb-4">
                  <h6 className="text-primary mb-2">
                    <i className="fas fa-map-marker-alt me-2"></i>
                    Address
                  </h6>
                  <p className="text-muted mb-0">{APP_COPY.contact.info.address}</p>
                </div>
                
                <div className="mb-4">
                  <h6 className="text-primary mb-2">
                    <i className="fas fa-phone me-2"></i>
                    Phone
                  </h6>
                  <p className="text-muted mb-0">{APP_COPY.contact.info.phone}</p>
                </div>
                
                <div className="mb-4">
                  <h6 className="text-primary mb-2">
                    <i className="fas fa-mobile-alt me-2"></i>
                    Mobile
                  </h6>
                  <p className="text-muted mb-0">{APP_COPY.contact.info.mobile}</p>
                </div>
                
                <div className="mb-4">
                  <h6 className="text-primary mb-2">
                    <i className="fas fa-envelope me-2"></i>
                    Email
                  </h6>
                  <p className="text-muted mb-0">{APP_COPY.contact.info.email}</p>
                </div>
                
                <div className="mb-4">
                  <h6 className="text-primary mb-2">
                    <i className="fas fa-clock me-2"></i>
                    Office Hours
                  </h6>
                  <p className="text-muted mb-0">{APP_COPY.contact.info.officeHours}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card contact__map-card shadow-sm">
              <div className="card-body">
                <h5 className="card-title mb-2">
                  <i className="fas fa-map-marked-alt me-2 text-primary"></i>
                  Retreat House Location
                </h5>
                <p className="card-text mb-3 text-muted" style={{ fontSize: '0.95rem' }}>
                  Find us on the map below. Click the button for directions to St Dominic's Bluff Retreat House.
                </p>
                <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' /* 16:9 aspect ratio */ }}>
                  <iframe
                    title="Retreat House Location"
                    src="https://www.google.com/maps?q=St+Dominic's+Bluff+Retreat+House&output=embed"
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0, borderRadius: '8px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div className="d-grid mt-3">
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=St+Dominic's+Bluff+Retreat+House"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm"
                  >
                    <i className="fas fa-directions me-2"></i>
                    Get Directions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 